import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataFieldComponentBase } from './datafield-base-component';
import { DataField } from './models/datafield';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'ep-datafield-checkbox',
    templateUrl: './datafield-checkbox.component.html',
    inputs: ['isAlwaysEditable', 'datafield', 'formValidationGroup'],
    outputs: ['valueChanged'] // It's necessary to set this, because the valueChanged method is placed in the base-class and not inherited if this is not set.
    ,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})

export class DataFieldCheckBoxComponent extends DataFieldComponentBase implements OnInit {

    constructor() {
        super();
    }

    // Inherited properties - because of the lack of decorator-inheritance
    //@Input() public isAlwaysEditable: boolean;
    //@Input() public datafield: DataField;

    public currentValue: boolean = false;

    override ngOnInit() {
        this.currentValue = (this.datafield.Value === 'True' || this.datafield.Value === 'true' || this.datafield.Value === true);
    }
}
